import Modules from '@/model/modules';
import {RouteModule} from '@/types/route-type';
import HoldBuy from './hold-buy/hold-buy';
import HoldDetail from './hold-detail/hold-detail';
import HoldList from './hold-list/hold-list';
import HoldSell from './hold-sell/hold-sell';

const Module: RouteModule = {
    module: Modules.HOLD,
    pages: [
        {
            path: '/hold',
            element: HoldList,
        },
        {
            path: '/hold/:id',
            element: HoldDetail,
        },
        {
            path: '/hold/buy',
            element: HoldBuy,
        },
        {
            path: '/hold/sell',
            element: HoldSell,
        },
    ],
};

export default Module;
